import React from 'react';
import { Row, Col, Form, Card, Badge, Alert } from 'react-bootstrap';
import { useCampaign } from '../CampaignContext';
import moment from 'moment';

const Step4Schedule = () => {
    const { state, dispatch } = useCampaign();
    const { schedule } = state;

    const handleScheduleChange = (type) => {
        dispatch({ type: 'UPDATE_SCHEDULE', payload: { type } });
    };

    return (
        <div className="py-2">
            <h5 className="font-weight-bold mb-3">Campaign Finalization & Scheduling</h5>
            
            <Alert variant="warning" className="border-0 shadow-sm small py-2 px-3 mb-4" style={{ borderRadius: '8px' }}>
                <i className="fas fa-exclamation-triangle mr-2" />
                <strong>Note:</strong> Messages are queued based on your account's daily limit and sender capacity.
            </Alert>

            <Row>
                <Col md={6}>
                    <Card 
                        className={`mb-4 border-2 p-4 wcm-card-selectable ${schedule.type === 'Immediate' ? 'active' : ''}`}
                        onClick={() => handleScheduleChange('Immediate')}
                    >
                        <div className="d-flex align-items-center mb-3">
                            <i className={`fas fa-bolt fa-2x mr-3 ${schedule.type === 'Immediate' ? 'text-primary' : 'text-muted'}`} />
                            <h6 className="m-0 font-weight-bold">Immediate Delivery</h6>
                        </div>
                        <p className="small text-muted mb-0">
                            The campaign will start processing within <strong className="text-dark">2 minutes</strong> of submission.
                        </p>
                    </Card>
                </Col>
                <Col md={6}>
                    <Card 
                        className={`mb-4 border-2 p-4 wcm-card-selectable ${schedule.type === 'Custom' ? 'active' : ''}`}
                        onClick={() => handleScheduleChange('Custom')}
                    >
                        <div className="d-flex align-items-center mb-3">
                            <i className={`fas fa-calendar-alt fa-2x mr-3 ${schedule.type === 'Custom' ? 'text-primary' : 'text-muted'}`} />
                            <h6 className="m-0 font-weight-bold">Scheduled Delivery</h6>
                        </div>
                        <p className="small text-muted mb-0">
                            Pick a specific date and time for your campaign to be triggered automatically.
                        </p>
                    </Card>
                </Col>
            </Row>

            {schedule.type === 'Custom' && (
                <Card className="border p-4 bg-white shadow-sm mb-4">
                    <Row className="align-items-center">
                        <Col md={6}>
                            <Form.Group className="mb-0">
                                <Form.Label className="small font-weight-bold text-muted">SELECT DATE & TIME</Form.Label>
                                <Form.Control 
                                    type="datetime-local" 
                                    className="wcm-input-md font-weight-bold"
                                    value={moment(schedule.date).format('YYYY-MM-DDTHH:mm')}
                                    onChange={(e) => dispatch({ type: 'UPDATE_SCHEDULE', payload: { date: new Date(e.target.value) } })}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6} className="text-muted small">
                            <p className="m-0 pl-3 border-left" style={{ borderLeftWidth: '3px !important' }}>
                                This will schedule the campaign according to your <strong className="text-dark">local timezone ({Intl.DateTimeFormat().resolvedOptions().timeZone})</strong>.
                            </p>
                        </Col>
                    </Row>
                </Card>
            )}

            <div className="p-3 bg-white rounded border d-flex justify-content-between align-items-center mt-4 shadow-sm">
                <div>
                    <h6 className="m-0 font-weight-bold" style={{ fontSize: '11px', color: '#64748b', letterSpacing: '1px' }}>SUMMARY</h6>
                    <p className="m-0 text-muted small">Targeting: <strong className="text-primary">{state.audience.matchingUsers.length || 4} Recipients</strong></p>
                </div>
                <div className="text-right">
                    <h6 className="m-0 font-weight-bold" style={{ fontSize: '11px', color: '#64748b', letterSpacing: '1px' }}>STATUS</h6>
                    <Badge variant={schedule.type === 'Immediate' ? 'success' : 'primary'} className="px-2 py-1" style={{ fontSize: '10px' }}>
                        {schedule.type === 'Immediate' ? 'READY TO SEND' : 'READY TO SCHEDULE'}
                    </Badge>
                </div>
            </div>
        </div>
    );
};

export default Step4Schedule;
